var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { PAGE_BRAND, PAGE_COUNTRY, PAGE_MARKET } from "../../../node_modules/@stellantis-hub/constants/dist/constants.mjs";
class V1 {
  constructor(clientHttp) {
    __publicField(this, "clientHttp");
    this.clientHttp = clientHttp;
  }
  async getDealersWorkingPrice(params) {
    const param = {
      brand: PAGE_BRAND,
      ...params
    };
    return this.clientHttp.get({ endpoint: "dealers/price", params: param });
  }
  async getUserDealersWorkingPrice(headers) {
    return this.clientHttp.useBearerToken().get({ endpoint: "dealers/working-price", headers });
  }
  async createDealersWorkingPrice({ body, headers }) {
    return this.clientHttp.useBearerToken().post({ endpoint: "dealers/working-price", body, headers });
  }
  async updateDealersWorkingPrice({ body, headers }) {
    return this.clientHttp.useBearerToken().put({ endpoint: "dealers/working-price", body, headers });
  }
  async getDealersWorkingPriceVisualizer({ params, headers }) {
    return this.clientHttp.useBearerToken().get({ endpoint: "dealers/working-price/visualizer", params, headers });
  }
  async getDealersWorkingPriceCSV({ params, headers }) {
    return this.clientHttp.useBearerToken().get({ endpoint: "dealers/working-price/visualizer/cvs", params, headers });
  }
  async getPrice(params) {
    return this.clientHttp.get({ endpoint: "price", params });
  }
  async getPriceReservation(params) {
    return this.clientHttp.get({ endpoint: "price/reservation", params });
  }
  async getSpecialDiscount(params) {
    return this.clientHttp.get({ endpoint: "price/specialDiscount", params });
  }
  async getPriceTypes(params) {
    return this.clientHttp.get({ endpoint: "price/types", params });
  }
  async getBatchPrices(params) {
    return this.clientHttp.get({ endpoint: "price/batchPrices", params });
  }
  async getBatchCustomPrice(params) {
    const products = JSON.stringify(params.products);
    return this.clientHttp.get({ endpoint: "price/batchCustomPrice", params: { products } });
  }
  async getAllPricesByLocation(params) {
    return this.clientHttp.get({ endpoint: "price", params });
  }
  async getPricesByURLParams(params) {
    return this.clientHttp.get({ endpoint: `price?mvsCode=${params.mvsCode}&year=${params.year}&country=${PAGE_COUNTRY}&market=${PAGE_MARKET}` });
  }
}
export {
  V1 as default
};
